import { jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M13 11.523H5.232l-.252.093-1.98.731V4.5h10v7.023l1.5-.402V3h-13v11.5l4-1.498h7.896L13 11.523Z"
      }
    )
  }
);
export {
  e as Message
};
